<script>
    import emotion from 'emotion/dist/emotion.umd.min.js';
    import {slide} from 'svelte/transition';
    import DataListItem from './DataListItem.svelte';
    import DataListParentItem from './DataListParentItem.svelte';

    export let showHeader = true;
    export let context = null;
    export let rows = [];
    export let header = {};
    export let showChildNumber = true;
    export let toggleComponent = null;
    export let onRowClick = () => {};
    export let childrenField = '';
    export let listFormConfig = null;
    export let menu = null;
    export let onShowMenu = () => {};
    export let editable = true;
    export let parentEntity = '';
    export let childEntity = '';
    export let onListItemFocus = () => {};
    export let draggable = true;

    let columns = {...header};
    let isHierarchy = false;
    let childHeader = {...header};
    let listToggleWidth = 0;

    $: if (header) {
        columns = {...columns, ...header};
    }

    const {css} = emotion;

    const rowCss = css`
        display: grid;
        grid-template-columns: ${getColumnTemmplate()};
        grid-auto-rows: fit-content(min-content, max-content);
    `;

    const childWrapperCss = css`
        grid-column-start: 1;
        grid-column-end: -1;
    `;

    const childRowCss = css`
        display: grid;
        grid-template-columns: ${getNestedColumnTemmplate()};
    `;

    const listFormCss = css`
        padding-left: ${listToggleWidth}px;
    `;


    function getColumnTemmplate() {
        let template = '';
        isHierarchy = childrenField ? true : false;

        if (isHierarchy) {
            listToggleWidth = toggleComponent ? 15 + toggleComponent.width : 15;
            const toggle = {
                width: listToggleWidth,
                component: toggleComponent ? toggleComponent.component : null,
            };
            columns = {
                toggle,
                ...header,
            };
        } else {
            if (toggleComponent) {
                columns = {toggleComponent, ...header};
            } else {
                columns = {...header};
            }
        }

        Object.keys(columns).forEach((c) => {
            template += columns[c].width ? `${columns[c].width}px ` : '1fr ';
        });

        if (menu && menu.parent) {
            template += '20px';
        }
        return template;
    }

    function getNestedColumnTemmplate() {
        let template = '';

        const toggle = {
            width: columns.toggle ? columns.toggle.width + 30 : 0,
        };

        if (showChildNumber) {
            const counter = {
                width: 25,
            };

            childHeader = {toggle, counter, ...columns};
        } else {
            childHeader = {toggle, ...columns};
        }

        Object.keys(childHeader).forEach((c) => {
            template += childHeader[c].width
                    ? `${childHeader[c].width}px `
                    : '1fr ';
        });

        if (menu && menu.children) {
            template += '20px';
        }

        return template;
    }

    function handleChildrenToggle(event, row) {
        event.stopPropagation();

        if (row.showChildren) {
            row.showChildren = false;
        } else {
            row.showChildren = true;
        }

        rows = [...rows];
    }

    function handleRowClick(event, row, parent, entity) {
        onRowClick(row, parent, event, entity);
    }

    function onDrop(event){
        // prevent drop
    }

</script>

<style>
    .data-grid {
        padding: 0;
        margin: 0;
        display: grid;
    }

    ol {
        padding: 0;
        list-style: none;
    }

    .data-grid :global(li > div) {
        overflow: hidden;
    }

    .data-grid :global(li) {
        border-bottom: 1px solid #dee2e6;
        cursor: default;
    }

    .data-grid :global(.children li:first-child) {
        border-top: 1px solid #dee2e6;
    }

    .data-grid :global(.children li.before:first-child) {
        border-top: 3px solid #454545;
    }

    .data-grid :global(li.before:first-child) {
        border-top: 3px solid #454545;
    }

    .data-grid :global(.children li.after:first-child) {
        border-bottom: 3px solid #454545;
    }

    .data-grid :global(li.after:last-child) {
        border-bottom: 3px solid #454545;
    }

    .data-grid :global(.children li.copied:first-child),
    .data-grid :global(.children li.cut:first-child) {
        border-top: 1px dashed #454545;
    }

    .data-grid :global(li:last-child) {
        border-bottom: none;
    }

    .data-grid :global(li.header) {
        font-weight: bold;
        background-color: #dee2e6;
    }

    :global(.right) {
        text-align: right;
    }

    .data-grid > :global(li:nth-child(n + 2)) > :global(.list-row:hover),
    .data-grid li > :global(.list-row.selected),
    .children :global(.list-row:hover), .children :global(.list-row.selected) {
        background-color: #ffecc9;
    }

    .children :global(.list-row.selected.active) {
        background-color: #FAB636;
    }

    .toggle {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-left: 2px;
    }
</style>

<ol class="data-grid">
    {#if showHeader}
        <li
                on:drop|preventDefault|stopPropagation={(onDrop)}
                class="header {rowCss}">
            {#each Object.keys(columns) as col}
                <div class={columns[col].class}>
                    {#if columns[col].headerRenderer}
                        <svelte:component
                                this={columns[col].headerRenderer}
                                col={columns[col]}/>
                    {:else}{columns[col].label ? columns[col].label : ''}{/if}
                </div>
            {/each}
        </li>
    {/if}
    {#each rows as row}
        <DataListParentItem
                item={row}
                entity={parentEntity}
                cssClass={rowCss}
                draggable={editable && draggable}
                {columns}
                on:showMenu={onShowMenu}
                {childrenField}
                {listFormConfig}
                onMouseDown={(event, item, parent) => handleRowClick(event, item, parent, parentEntity)}
                {handleChildrenToggle}
                on:itemMoved
        >
            <ol
                    slot="children"
                    class="children {childWrapperCss}"
                    transition:slide={{ duration: 500 }}>
                {#each row[childrenField] as item, index}
                    <DataListItem
                            {item}
                            entity={childEntity}
                            cssClass={childRowCss}
                            parent={row}
                            onMouseDown={(event, item, parent) => handleRowClick(event, item, parent, childEntity)}
                            on:showMenu={onShowMenu}
                            {columns}
                            {index}
                            draggable={editable}
                            on:itemMoved
                            onFocus="{onListItemFocus}"
                    />
                {/each}
                    <!--
                        show add children row here
                    -->
                {#if listFormConfig && listFormConfig[childrenField] &&
                listFormConfig[childrenField].form && listFormConfig.editable}
                    <li class="list-form {listFormCss}" data-index={row[childrenField].length}>
                        <svelte:component
                                this={listFormConfig[childrenField].form}
                                item={row}
                                createNew={listFormConfig[childrenField].createNew}/>
                    </li>
                {/if}
            </ol>
        </DataListParentItem>

    {/each}
        <!--
            show add parent row here
        -->
    {#if listFormConfig && listFormConfig.form && listFormConfig.editable}
        <svelte:component
                this={listFormConfig.form}
                actionApi={listFormConfig.actionApi}
                {context}/>
    {/if}
</ol>
